import * as types from '../types'

export const initialState = {
  userExpired: false,
}

export default (state = initialState, action: any) => {
  switch (action.type) {
    case types.SHOW_AUTH_MODAL:
      return {
        ...state,
        showAuthModal: true,
      }
    case types.HIDE_AUTH_MODAL:
    case types.NAVIGATE_TO_REGISTER:
      return {
        ...state,
        showAuthModal: false,
      }
    case types.UPDATE_AUTH:
      return {
        ...state,
      }
    default:
      return { ...state }
  }
}
